import { useLeadStore, usePipedriveStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";
import { ILeadCreateState } from "../interfaces/ILead";

const useLeadCreate = (): (leadState: ILeadCreateState, centerPoint: IGeoCoordinate, parcelId: string) => Promise<number> => {
    const leadStore = useLeadStore();
    const pipedriveStore = usePipedriveStore();

    return async (leadState: ILeadCreateState, centerPoint: IGeoCoordinate, parcelId: string): Promise<number> => {
        try {
            const createdLeadId = await leadStore.createLead(
                leadState,
                centerPoint,
                parcelId,
                await pipedriveStore.getOrCreatePipedriveOrganizationId(leadState.pipedriveCompanyName),
            );

            showSuccessToast();

            return createdLeadId;
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLeadCreate;